export default "__VITE_ASSET__Cg7acbyh__"